import React, { useEffect, useState, useRef } from "react";
import ReactECharts from "echarts-for-react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { FaFilter, FaSlidersH, FaChevronUp, FaChevronDown } from "react-icons/fa";
import axios from "axios";
import { BASE_URL } from "../../../commonConfig/ApiConfig";
import { FaSortAmountDownAlt, FaSortAmountUpAlt } from "react-icons/fa"
import Stackedchart_FilterPopup from "./filtercomponents/stackedchart_filter";
import WorkspaceSidePanel from "components/cmn_workspace/workspace_button";
import WorkspaceButton from "components/pages/workspacebtn/workspacebtn";
import { setWorkspaceLoaded } from 'store/workspaceSlice';
import { MdInfoOutline } from "react-icons/md";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useBreakpoints } from 'hooks/useBreakpoints';
import SaveCharts from 'components/pages/map/mapConfig/SaveChart';

const StackedBarChart = ({ chart_location_payload }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const chartRef = useRef(null);
  const { breakpoints } = useBreakpoints();
  //=========== Mobile View =============
  const isMobile = breakpoints.down('md');
  const [sortConfig, setSortConfig] = useState({
    type: null, // 'location' | 'subIndicator'
    key: null, // subIndicator name
    direction: 'asc', // 'asc' | 'desc'
  });
  // Workspace toggle state
  const [showWorkspace, setShowWorkspace] = useState(true);
  const dispatch = useDispatch();
  const selectedMapFeatures = useSelector(state => state.workspace.selectedMapFeatures);

  const handleVisualize = (selectedIndicators) => {
    navigate('/mapconfig', { state: { selectedIndicators, selectedMapFeatures } });
  };
  const handleSaveSuccess = (workspaceData) => {
    alert(`Workspace "${workspaceData.name}" saved successfully!`);

    // Always load the saved workspace as current
    if (workspaceData.id && workspaceData.name) {
      setTimeout(() => {
        dispatch(setWorkspaceLoaded({
          id: workspaceData.id,
          name: workspaceData.name,
          workspace: workspaceData
        }));
      }, 100);
    }
  };

  const { formattedPayload, payload, reduxPayload } = location.state || {};
  const [mainpayload, setmainpayload] = useState(chart_location_payload || payload);
  const [mainformattedpayload, setmainformattedpayload] = useState(chart_location_payload || formattedPayload);
  const [selectedItems, setSelectedItems] = useState([]);

  const [isChartOptionOpen, setChartOptionOpen] = useState(false);
  const [showFilterPopup, setShowFilterPopup] = useState(false);
  const [selectedLocations, setSelectedLocations] = useState(
    (mainformattedpayload?.location_info || [])
      .filter((loc) => {
        const locCode = loc.code || loc.properties?.code || loc.lgd_code;
        const geoLevel = loc.geo_level || loc.geo_level_code;

        return (mainpayload?.lgd_codes || []).some(
          (lgd) => lgd.code === locCode && lgd.geo_level_code === geoLevel
        );
      })
      .map((loc) => ({
        label: loc.name || loc.label,
        value: loc.code || loc.properties?.code || loc.lgd_code,
        geo_level: loc.geo_level || loc.geo_level_code,
        id: `${loc.geo_level || loc.geo_level_code}-${loc.code || loc.properties?.code || loc.lgd_code}`,
      }))
  );

  const fetchLocations = async (lgd_code, geo_level_code) => {
    try {
      const res = await axios.post(`${BASE_URL}locations/location-details`, {
        lgd_code,
        geo_level_code,
      });
      return res.data.locations || [];
    } catch (err) {
      console.error("Error fetching locations:", err);
      return [];
    }
  };

  const [apiData, setApiData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [Flipaxis, setFlipaxis] = useState(true)
  const [isExportDropdownOpen, setExportDropdownOpen] = useState(false);
  useEffect(() => {
    if (formattedPayload.chartType === "bar") {
      setFlipaxis(false)
    } else {
      setFlipaxis(true)
    }
  }, [formattedPayload]);
  useEffect(() => {
    const fetchData = async () => {
      if (!mainpayload) return;
      try {
        const res = await axios.post(`${BASE_URL}indicators/stacked-chart`, mainpayload);
        setApiData(res.data);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching data:", err);
        setError("Failed to fetch chart data.");
        setLoading(false);
      }
    };
    fetchData();
  }, [mainpayload]);
  useEffect(() => {
    // ✅ Always define handlers, but conditionally check inside
    const handleClickOutside = (event) => {
      // Only process if at least one dropdown is open
      if (!isExportDropdownOpen && !isChartOptionOpen) return;

      const exportButton = document.querySelector('.btn.btn-sm.btn-primary');
      const exportMenu = document.querySelector('.dropdown-menu.show');
      const chartButton = document.querySelector('.btn.btn-primary:not(.btn-sm)');
      const chartMenu = document.querySelector('.position-absolute.bg-white');

      // Close export dropdown if click outside
      if (
        isExportDropdownOpen &&
        exportMenu &&
        !exportMenu.contains(event.target) &&
        exportButton &&
        !exportButton.contains(event.target)
      ) {
        setExportDropdownOpen(false);
      }

      // Close chart options if click outside
      if (
        isChartOptionOpen &&
        chartMenu &&
        !chartMenu.contains(event.target) &&
        chartButton &&
        !chartButton.contains(event.target)
      ) {
        setChartOptionOpen(false);
      }
    };

    const handleEscKey = (event) => {
      // Only process if at least one dropdown is open
      if (!isExportDropdownOpen && !isChartOptionOpen) return;

      if (event.key === 'Escape') {
        setExportDropdownOpen(false);
        setChartOptionOpen(false);
      }
    };

    // ✅ Always attach listeners (lightweight operations)
    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleEscKey);

    // ✅ Always cleanup
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscKey);
    };
  }, [isExportDropdownOpen, isChartOptionOpen]);


  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;
  if (!apiData?.indicator_values || apiData.indicator_values.length === 0)
    return (
      <>
        <div className="container-fluid mt-4">
          <div className="alert alert-info p-4">
            <h4 className="alert-heading">No data available</h4>
            <hr />
            <p className="mb-2"><strong>Possible Reasons:</strong></p>
            <ul className="mb-0">
              <li className="mb-2">Selected Locations do not match the Geo levels of the selected indicators</li>
              <li className="mb-2">
                Selected indicator values do not exist for the selected locations. Verify this by visiting the locations pages and click on Show Indicator button. The location pages list all indicators having data available for the selected location or its sub levels.
                <p className="mt-2 ms-3"><em>Ex: In Karnataka page, the show indicators will list the indicators having data for Karnataka, its districts and its ULBs.</em></p>
              </li>
            </ul>
            <div className="text-end">
              <button className="btn btn-primary" onClick={() => navigate('/mapconfig', { state: mainformattedpayload })}>
                <FaSlidersH className="me-1" /> Go Back to Chart Configuration
              </button>
            </div>
          </div>
        </div>
      </>
    );
  const geoLevelLabel = (level) => {
    switch (level) {
      case 1: return "National";
      case 2: return "State / UT";
      case 3: return "District";
      case 4: return "ULG";
      default: return "Unknown";
    }
  };

  const generateStackedBarChart = (indicators, Flipaxis) => {
    const allStates = new Set();
    const allSubIndicators = new Set();

    // Step 1: Collect all unique states and sub-indicators
    indicators.forEach((indicator) => {
      indicator.location_values.forEach((loc) => {
        allStates.add(loc.location_name);
        loc.values.forEach((entry) => {
          const key = Object.keys(entry)[0];
          allSubIndicators.add(`${key}__${indicator.indicator_name}`); // Unique key
        });
      });
    });

    const states = Array.from(allStates);
    // 🔀 Apply sorting based on sortConfig
    if (sortConfig.type === "subIndicator" && sortConfig.key) {
      const key = sortConfig.key;
      states.sort((a, b) => {
        let valA = 0, valB = 0;

        indicators.forEach((indicator) => {
          indicator.location_values.forEach((loc) => {
            if (loc.location_name === a) {
              loc.values.forEach((entry) => {
                if (entry[key] !== undefined) {
                  valA = parseFloat(entry[key]) || 0;
                }
              });
            }
            if (loc.location_name === b) {
              loc.values.forEach((entry) => {
                if (entry[key] !== undefined) {
                  valB = parseFloat(entry[key]) || 0;
                }
              });
            }
          });
        });

        return sortConfig.direction === "asc" ? valA - valB : valB - valA;
      });
    }

    if (sortConfig.type === "location") {
      states.sort((a, b) => {
        if (sortConfig.direction === "asc") return a.localeCompare(b);
        return b.localeCompare(a);
      });
    }


    // Step 2: Build a map: { [indicatorName]: { [subIndicatorName]: { [state]: value } } }
    const dataMap = {};

    indicators.forEach((indicator) => {
      const indicatorName = indicator.indicator_name;
      dataMap[indicatorName] = {};

      indicator.location_values.forEach((loc) => {
        const state = loc.location_name;

        loc.values.forEach((entry) => {
          const [key, val] = Object.entries(entry)[0];

          if (!dataMap[indicatorName][key]) {
            dataMap[indicatorName][key] = {};
          }

          dataMap[indicatorName][key][state] = parseFloat(val || "0");
        });
      });
    });

    // Step 3: Build series
    const series = [];

    indicators.forEach((indicator, index) => {
      const indicatorName = indicator.indicator_name;
      const indicator_date = indicator.indicator_date;
      const subIndMap = dataMap[indicatorName];

      Object.keys(subIndMap).forEach((subInd) => {
        const valuesByState = subIndMap[subInd];

        // Compute total per state for percentage
        const totalsPerState = {};
        states.forEach((state) => {
          totalsPerState[state] = 0;
        });

        Object.values(subIndMap).forEach((stateValues) => {
          states.forEach((state) => {
            totalsPerState[state] += stateValues[state] || 0;
          });
        });

        // Now generate percentage series
        const data = states.map((state) => {
          const val = valuesByState[state] || 0;
          const total = totalsPerState[state];
          return total > 0 ? +((val / total) * 100).toFixed(2) : 0;
        });

        series.push({
          name: `${subInd} (${indicatorName}${indicator_date})`,
          type: "bar",
          stack: `indicator_${index}`,
          emphasis: { focus: "series" },
          label: {
            show: false,
            position: "inside",
            formatter: "{c}%",
          },
          data,
        });
      });
    });
    const generateColors = (count) => {
      return Array.from({ length: count }, (_, i) => {
        const hue = (i * 137.5) % 360; // Use golden angle to spread hues
        return `hsl(${hue}, 65%, 55%)`;
      });
    };
    const customColors = generateColors(series.length);

    // Chart options
    return {
      color: customColors,
      title: {
        text: `${indicators[0].indicator_name} ${indicators[0].indicator_date}`,
        left: 'center',
        top: 10,
        textStyle: {
          fontSize: 16,
          fontWeight: 'bold'
        }
      },
      tooltip: {
        trigger: "axis",
        axisPointer: { type: "shadow" },
        formatter: (params) =>
          params
            .map(
              (item) =>
                `${item.marker} ${item.seriesName}: ${item.value.toFixed(1)}%`
            )
            .join("<br/>"),
      },
      grid: {
        top: 60,
        bottom: isMobile ? 350 : 200,
        left: isMobile ? 0 : 60,
        right: isMobile ? 0 : 60,
        containLabel: true,
      },
      legend: {
        orient: "horizontal",
        bottom: 0,
        type: "plain",
        itemGap: isMobile ? 10 : 30,
        formatter: function (name) {
          const parts = name.split(" (");
          const label = parts[0];
          return `{a|${label}}`;
        },
        textStyle: {
          rich: {
            a: {
              fontWeight: "bold",
              color: "#333",
              fontSize: 12,
              padding: [5, 0, 0, 0],
            },
            b: {
              color: "#555",
              fontSize: 11,
            },
          },
        },
      },
      xAxis: Flipaxis
        ? {
          type: "category",
          data: states,
          axisLabel: {
            interval: 0,
            rotate: 90,
          },
        }
        : {
          type: "value",
          max: 100,
          axisLabel: {
            formatter: "{value}%",
          },
        },
      yAxis: Flipaxis
        ? {
          type: "value",
          max: 100,
          axisLabel: {
            formatter: "{value}%",
          },
        }
        : {
          type: "category",
          data: states,
          axisLabel: {
            interval: 0,
            rotate: 0,
          },
        },
      series,
    };
  };

  // const handleFilterApply = (newSelected) => {
  //   // newSelected: array of { label, value, geo_level, id }
  //   setSelectedLocations(newSelected);
  //   const fetchData = async (payload) => {
  //     try {
  //       const res = await axios.post(`${BASE_URL}indicators/pie-chart`, payload);
  //       setApiData(res.data);
  //       setLoading(false);
  //     } catch (err) {
  //       console.error("Error fetching data:", err);
  //       setError("Failed to fetch chart data.");
  //       setLoading(false);
  //     }
  //   };

  //   const updatedPayload = {
  //     ...mainpayload,
  //     lgd_codes: newSelected.map((loc) => ({
  //       code: loc.lgd_code,
  //       geo_level_code: loc.geo_level,
  //     })),
  //   };

  //   setApiData(null);
  //   setLoading(true);
  //   fetchData(updatedPayload);
  // };

  const handleFilterApply = (selectedItemsFromPopup, oldpayload) => {
    if (!selectedItemsFromPopup || selectedItemsFromPopup.length === 0) {
      alert("Please select at least one location");
      return;
    }

    // ✅ Step 1: Get existing items from old payload
    const existingCodes = (oldpayload.lgd_codes || []).map(item => ({
      code: item.code,
      geo_level_code: item.geo_level_code,
      ...(item.type && { type: item.type })
    }));

    const existingLocations = (oldpayload.selected_Location || []).map(item => ({
      value: item.value,
      label: item.label,
      geo_level: item.geo_level
    }));

    // ✅ Step 2: Create sets for comparison (using lgd_code as key)
    const existingCodesSet = new Set(
      existingCodes.map(item => `${item.code}-${item.geo_level_code}`)
    );

    const selectedCodesSet = new Set(
      selectedItemsFromPopup.map(item => `${item.lgd_code}-${item.geo_level}`)
    );

    // ✅ Step 3: Filter out items from old payload that are NOT in selected
    const filteredExistingCodes = existingCodes.filter(item =>
      selectedCodesSet.has(`${item.code}-${item.geo_level_code}`)
    );

    const filteredExistingLocations = existingLocations.filter(item =>
      selectedCodesSet.has(`${item.value}-${item.geo_level}`)
    );

    // ✅ Step 4: Add new items that are NOT in old payload
    const newItemsToAdd = selectedItemsFromPopup.filter(item =>
      !existingCodesSet.has(`${item.lgd_code}-${item.geo_level}`)
    );

    const newCodesToAdd = newItemsToAdd.map(item => ({
      code: item.lgd_code,
      geo_level_code: item.geo_level
    }));

    const newLocationsToAdd = newItemsToAdd.map(item => ({
      value: item.lgd_code,
      label: item.name,
      geo_level: item.geo_level
    }));

    // ✅ Step 5: Combine filtered existing + new items
    const finalCodes = [...filteredExistingCodes, ...newCodesToAdd];
    const finalLocations = [...filteredExistingLocations, ...newLocationsToAdd];

    // ✅ Step 6: Create updated payload
    const updatedPayload = {
      ...oldpayload,
      lgd_codes: finalCodes,
      selected_Location: finalLocations,
    };

    //to know wht is being add or deleted from the old payload
    // console.log("📌 Applying filters:", {
    //     existingCount: existingCodes.length,
    //     selectedCount: selectedItemsFromPopup.length,
    //     removedCount: existingCodes.length - filteredExistingCodes.length,
    //     addedCount: newItemsToAdd.length,
    //     finalCount: finalCodes.length
    // });

    setSelectedItems(selectedItemsFromPopup); // ✅ Update selected UI list
    setmainpayload(updatedPayload);        // ✅ This triggers bar chart API fetch
    //setMainFormattedPayload(updatedPayload); // For navigation or config
  };

  /////////////////////
  //  export feature
  /////////////////////
  const handleExportCSV = () => {
    if (!apiData?.indicator_values || apiData.indicator_values.length === 0) return;

    const indicators = apiData.indicator_values;

    const allStates = new Set();
    const allSubIndicatorsPerIndicator = {}; // { Indicator A: [Sub1, Sub2], ... }
    const dataMap = {}; // { state: { subIndicator: value } }

    // Collect all unique sub-indicators and values
    indicators.forEach((indicator) => {
      const indicatorName = indicator.indicator_name;

      if (!allSubIndicatorsPerIndicator[indicatorName]) {
        allSubIndicatorsPerIndicator[indicatorName] = [];
      }

      indicator.location_values.forEach((loc) => {
        const state = loc.location_name;
        allStates.add(state);

        if (!dataMap[state]) dataMap[state] = {};

        const total = loc.values.reduce((sum, entry) => {
          const val = Object.values(entry)[0];
          return sum + (parseFloat(val) || 0);
        }, 0);

        loc.values.forEach((entry) => {
          const [key, val] = Object.entries(entry)[0];

          // Add subindicator if not already present
          if (!allSubIndicatorsPerIndicator[indicatorName].includes(key)) {
            allSubIndicatorsPerIndicator[indicatorName].push(key);
          }

          const percentage = total > 0 ? (parseFloat(val) / total) * 100 : 0;
          dataMap[state][key] = +percentage.toFixed(2);
        });
      });
    });

    const states = Array.from(allStates);

    // Prepare header rows
    const indicatorRow = ["Location"]; // First cell for "Location"
    const subIndicatorRow = [""];

    Object.entries(allSubIndicatorsPerIndicator).forEach(([indicatorName, subIndicators], index) => {
      subIndicators.forEach((subInd, idx) => {
        // Only write indicator name once, then leave empty for next columns
        indicatorRow.push(idx === 0 ? indicatorName : "");
        subIndicatorRow.push(subInd);
      });
    });

    // Build CSV content
    let csv = "data:text/csv;charset=utf-8,";
    csv += indicatorRow.join(",") + "\n";
    csv += subIndicatorRow.join(",") + "\n";

    // Data rows
    states.forEach((state) => {
      const row = [state];
      Object.entries(allSubIndicatorsPerIndicator).forEach(([_, subIndicators]) => {
        subIndicators.forEach((subInd) => {
          row.push(dataMap[state]?.[subInd] ?? "0.00");
        });
      });
      csv += row.join(",") + "\n";
    });

    // Trigger download
    const encodedUri = encodeURI(csv);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    const timestamp = new Date().toISOString()
      .replace(/T/, '_')      // Replace 'T' with '_'
      .replace(/:/g, '-')     // Replace ':' with '-'
      .replace(/\..+/, '');   // Remove milliseconds
    const filename = `stacked_chart_${timestamp}.csv`;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleExportImage = () => {
    if (!chartRef.current) return;

    const echartsInstance = chartRef.current.getEchartsInstance();
    const imgData = echartsInstance.getDataURL({
      type: "png",
      pixelRatio: 2,
      backgroundColor: "#fff",
    });

    const link = document.createElement("a");
    const timestamp = new Date().toISOString()
      .replace(/T/, '_')      // Replace 'T' with '_'
      .replace(/:/g, '-')     // Replace ':' with '-'
      .replace(/\..+/, '');   // Remove milliseconds
    const filename = `stacked_chart_image_${timestamp}.png`;
    link.href = imgData;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <WorkspaceButton
        showWorkspace={showWorkspace}
        setShowWorkspace={setShowWorkspace}
      />
      <WorkspaceSidePanel showWorkspace={showWorkspace}
        setShowWorkspace={setShowWorkspace}
        onVisualize={handleVisualize}
        onSaveSuccess={handleSaveSuccess} />
      <div className="container-fluid" style={{ height: "100%", width: "100%" }}>
        {location.pathname === "/stackedcolumnchart" && (
          <div className="row mb-3 p-2">
            <div className="col-12">
              <h3 className="fw-bold">Data Analysis</h3>
              <hr />
            </div>
          </div>
        )}
        <div className="row">
          {/* Controls */}
          <div className="d-flex justify-content-between align-items-center mb-3 px-2">
            <div className="d-flex gap-2">
              <button
                className="btn btn-sm btn-primary"
                onClick={() => setShowFilterPopup(true)}
              >
                <FaFilter className="me-1" /> Filters
              </button>
              {location.pathname !== "/location" && (<>
                <button
                  className="btn btn-outline-secondary"
                  onClick={() =>
                    navigate("/mapconfig", { state: mainformattedpayload })
                  }
                >
                  <FaSlidersH className="me-1" /> Go Back to Chart Configuration
                </button><OverlayTrigger
                  placement="right"
                  overlay={
                    <Tooltip id="filter-tooltip">
                      <ol className="mb-0 ps-3">
                        <li>Click on 'Go to Chart configuration' to add more indicators to the chart from the workspace.</li>
                        <li>Go to 'Home' menu link to add additional indicators to the workspace.</li>
                      </ol>
                    </Tooltip>
                  }
                >
                  <span>
                    <MdInfoOutline size={20} style={{ cursor: "pointer", color: "#000000" }} />
                  </span>
                </OverlayTrigger>
                <SaveCharts className="" payload={payload} formattedPayload={formattedPayload} path="/stackedcolumnchart" reduxPayload={reduxPayload} />
              </>
              )}
              {/* <button className="btn btn-success btn-sm end" onClick={handleExportCSV}>
              Export CSV
            </button> */}

            </div>
            {!isMobile && (
              <div className="  d-flex gap-2 dropdown text-end ">
                <button
                  className="btn btn-sm btn-primary text-end"
                  type="button"
                  onClick={() => setExportDropdownOpen((prev) => !prev)}
                >
                  Export{isExportDropdownOpen ? <FaChevronUp /> : <FaChevronDown />}
                </button>

                <div className="dropdown  px-2 position-relative">
                  <button
                    className="btn btn-primary "
                    type="button"
                    onClick={() => setChartOptionOpen((prev) => !prev)}
                  >
                    Chart Options {isChartOptionOpen ? <FaChevronUp /> : <FaChevronDown />}
                  </button>

                  {isChartOptionOpen && (
                    <div
                      className="position-absolute bg-white border rounded shadow p-3"
                      style={{ top: '100%', right: 0, zIndex: 1000, minWidth: '250px' }}
                    >
                      <div className="mb-2 ">
                        <h4 className="mb-2 fs-1 p-1">Sort</h4>
                        <div
                          className={`p-2 rounded d-flex align-items-center justify-content-between mb-3 ${sortConfig.type === 'location' ? "bg-light border border-primary" : "border"}`}
                          role="button"
                          onClick={() =>
                            setSortConfig(prev => ({
                              type: 'location',
                              key: null,
                              direction: prev.direction === 'asc' ? 'desc' : 'asc',
                            }))
                          }
                        >
                          <span>Locations</span>
                          {sortConfig.type === 'location' ? (
                            sortConfig.direction === 'asc' ? (
                              <FaSortAmountDownAlt style={{ height: '20px', width: '20px' }} />
                            ) : (
                              <FaSortAmountUpAlt style={{ height: '20px', width: '20px' }} />
                            )
                          ) : (
                            <FaSortAmountDownAlt style={{ opacity: 0.0 }} />
                          )}
                        </div></div>

                      {/* Sub Indicators */}
                      <ul className="list-group gap-2">
                        {(() => {
                          const subIndicatorsSet = new Set();
                          apiData.indicator_values.forEach(ind =>
                            ind.location_values.forEach(loc =>
                              loc.values.forEach(val =>
                                Object.keys(val).forEach(k => subIndicatorsSet.add(k))
                              )
                            )
                          );
                          return Array.from(subIndicatorsSet).map((subInd, idx) => {
                            const isActive = sortConfig.type === 'subIndicator' && sortConfig.key === subInd;
                            const direction = sortConfig.direction;

                            return (
                              <li
                                key={idx}
                                className={`p-2 rounded d-flex align-items-center justify-content-between ${isActive ? "bg-light border border-primary" : "border"}`}
                                role="button"
                                onClick={() => {
                                  setSortConfig(prev => ({
                                    type: 'subIndicator',
                                    key: subInd,
                                    direction: prev.key === subInd && prev.direction === 'asc' ? 'desc' : 'asc',
                                  }));
                                }}
                              >
                                <span className="small fw-bold truncate-with-tooltip " title={subInd} style={{
                                  maxWidth: '150px',
                                  whiteSpace: 'nowrap',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  display: 'inline-block',
                                  verticalAlign: 'middle',
                                }}>
                                  {subInd}
                                </span>
                                <div>
                                  {isActive ? (
                                    direction === 'asc' ? (
                                      <FaSortAmountDownAlt style={{ height: '20px', width: '20px' }} />
                                    ) : (
                                      <FaSortAmountUpAlt style={{ height: '20px', width: '20px' }} />
                                    )
                                  ) : (
                                    <FaSortAmountDownAlt style={{ opacity: 0.0 }} />
                                  )}
                                </div>
                              </li>
                            );
                          });
                        })()}
                      </ul>
                    </div>
                  )}
                </div>

                {isExportDropdownOpen && (
                  <ul
                    className="dropdown-menu show"
                    style={{
                      display: "block",
                      position: "absolute",
                      top: "100%",
                      left: 0,
                      zIndex: 1000,
                    }}
                  >
                    <li>
                      <button className="dropdown-item" onClick={handleExportCSV}>
                        Export as CSV
                      </button>
                    </li>
                    <li>
                      <button className="dropdown-item" onClick={handleExportImage}>
                        Export as Image
                      </button>
                    </li>
                  </ul>
                )}
              </div>)}
          </div>
          {showFilterPopup && (
            <Stackedchart_FilterPopup
              show={showFilterPopup}
              onClose={() => setShowFilterPopup(false)}
              onApply={handleFilterApply}
              mainpayload={mainpayload}
              selectedItems={selectedLocations}
              setSelectedItems={setSelectedLocations}
              workspace_locations={mainformattedpayload?.location_info || []}
              fetchLocations={fetchLocations}
            />
          )}
          <div className="col-12" >
            <div className="card shadow-sm" style={{ minHeight: Flipaxis ? "80vh" : "130vh" }}>
              <ReactECharts
                ref={chartRef}
                option={generateStackedBarChart(apiData.indicator_values, Flipaxis)}
                style={{
                  height: "800px",
                  minHeight: Flipaxis ? "80vh" : "130vh",
                  width: isMobile ? "100%" : "1600px",
                }}
              />
            </div>
          </div>

          {/* Info sections */}
          <div className="col-12" style={{ height: "30%" }}>
            <div className="row ">
              {/* Indicators */}
              <div className="col-md-8 bg-light p-3" style={{ overflowY: "auto" }}>
                <h5 className="f-14 fw-bold">Chart Indicators</h5>
                {(() => {

                  const selectedICodes = (mainpayload?.indicators || []).map(String); // Normalize

                  const indicatorsInfo = mainformattedpayload?.indicator_info
                    ? Object.values(mainformattedpayload.indicator_info).filter((ind) => {
                      const code = String(ind.indicator_code);
                      const match = selectedICodes.includes(code);
                      return match;
                    })
                    : [];

                  return indicatorsInfo.length === 0 ? (
                    <p className="text-muted">No indicators selected</p>
                  ) : (
                    <ul className="list-group mb-3">
                      {indicatorsInfo.map((ind, index) => (
                        <li
                          key={ind.indicator_code || index}
                          className="list-group-item"
                        >
                          <div className="d-flex align-items-start">
                            <span className="badge bg-secondary me-2">
                              {index + 1}
                            </span>
                            <div>
                              <div className="fw-bold text-primary" style={{ fontSize: "13px" }}>
                                {ind.indicator_name && (
                                  <>
                                    <span>{ind.indicator_name}</span>
                                    {ind.dataset_name && <span> ({ind.dataset_name})</span>}
                                  </>
                                )}

                                {ind.indicator_date && ind.indicator_date !== "NA" && (
                                  <>
                                    {" | "}
                                    <span
                                      style={{
                                        backgroundColor: "#2c7ce5",
                                        color: "#fff",
                                        padding: "0 6px",
                                        borderRadius: "4px",
                                        fontSize: "12px",
                                      }}
                                    >
                                      {ind.indicator_date}
                                    </span>
                                  </>
                                )}

                                {ind.agency_name && ind.agency_name !== "NA" && (
                                  <>
                                    {" | "}
                                    <span>{ind.agency_name}</span>
                                  </>
                                )}

                                {/* {Array.isArray(ind.geo_levels) && ind.geo_levels.length > 0 && (
                                  <>
                                    {" | "}
                                    <span>{ind.geo_levels.join(", ")}</span>
                                  </>
                                )} */}
                              </div>
                              <div className="text small">
                                {/* Available Geo Levels Section */}
                                {ind.geo_levels && ind.geo_levels.length > 0 && (
                                  <div className="mt-1 mb-1">
                                    <span className="me-2" style={{ fontSize: "0.875rem" }}>Available Geo Levels:</span>
                                    {ind.geo_levels.map((level, idx) => (
                                      <span
                                        key={idx}
                                        style={{
                                          backgroundColor: "#28a745",
                                          color: "#fff",
                                          borderRadius: "0.25rem",
                                          padding: "0.2rem 0.5rem",
                                          marginRight: "0.3rem",
                                          fontSize: "0.75rem",
                                          display: "inline-block"
                                        }}
                                      >
                                        {level}
                                      </span>
                                    ))}
                                  </div>
                                )}
                                {[
                                  ind.sector_name,
                                  ind.sub_sector_name,
                                  ind.sub_sub_sector_name,
                                ]
                                  .filter((val) => val && val !== "NA")
                                  .join(" | ")}
                              </div>
                            </div>
                          </div>
                        </li>
                      ))}
                    </ul>
                  );
                })()}
              </div>

              {/* Locations */}
              <div className="col-md-4 bg-light p-3" style={{ overflowY: "auto" }}>
                <h5 className="f-14 fw-bold">Locations</h5>
                {(() => {
                  const locations = apiData?.location_info || mainformattedpayload?.location_info;
                  return locations.length === 0 ? (
                    <p className="text-muted">No locations selected</p>
                  ) : (
                    <ul className="list-group mb-3">
                      {locations.map((loc, idx) => (
                        <li key={`loc-${idx}`} className="list-group-item">
                          <div className="d-flex align-items-start">
                            <span className="fw-bold f-14">{idx + 1}.&nbsp;</span>
                            <div ><span className="fw-bold f-14">{loc.label}&nbsp;</span><span className="small text-secondary f-12">({geoLevelLabel(loc.geo_level_code || loc.geo_level || 4)})</span></div>
                          </div>
                        </li>
                      ))}
                    </ul>
                  );
                })()}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StackedBarChart;
